import { render, staticRenderFns } from "./NavOurServicesEn.vue?vue&type=template&id=1be76113"
import script from "./NavOurServicesEn.vue?vue&type=script&lang=ts"
export * from "./NavOurServicesEn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavButton: require('/app/components/rebrand-header/NavButton.vue').default,NavMenuItem: require('/app/components/rebrand-header/NavMenuItem.vue').default,NavLoginButton: require('/app/components/rebrand-header/NavLoginButton.vue').default,NavAllServicesEn: require('/app/components/rebrand-header/NavAllServicesEn.vue').default,NavMenu: require('/app/components/rebrand-header/NavMenu.vue').default})
